"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScaleDensity = useScaleDensity;
var _useScale = require("./useScale");
function useScaleDensity() {
  const scale = (0, _useScale.useScale)();
  return scale === 'xSmall' || scale === 'small' || scale === 'medium' ? 'dense' : 'normal';
}